import { render, staticRenderFns } from "./maintenance-price-value.vue?vue&type=template&id=4208754d&lang=pug"
import script from "./maintenance-price-value.vue?vue&type=script&lang=js"
export * from "./maintenance-price-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports